import googleSvg from "images/Google.svg";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux/store";
import { googleSignIn } from "../../redux/reducers/AuthSlice/AuthSlice";
import { getCurrentUser } from "../../redux/reducers/UserSlice/UserSlice";
import { useNavigate } from "react-router-dom";
import successHandler from "../../utils/helpers/SuccessHandler";
import ErrorHandler from "utils/helpers/ErrorHandler";
import { useLocation } from "react-router-dom";

function SocialAuth() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSocialLogin = (accessToken: string, type: string) => {
    dispatch(googleSignIn({ token: accessToken, type }))
      .unwrap()
      .then((response) => {
        if (response?.success) {
          localStorage.setItem("authToken", response?.access_token);
          successHandler(response?.message || "Logged in successfully");
          dispatch(getCurrentUser())
            .unwrap()
            .then((res) => {
              if (res?.success) {
                const redirectPath = location.state?.from || "/";
                navigate(res?.data?.email_verified ? redirectPath : "/account");
              }
            });
        }
      })
      .catch(() => ErrorHandler(new Error(`Error in ${type} login`)));
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      if (tokenResponse.access_token) {
        handleSocialLogin(tokenResponse.access_token, "google");
      }
    },
    onError: () => ErrorHandler(new Error("Error in Google login")),
  });

  return (
    <button
      onClick={() => googleLogin()}
      className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-xl border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 hover:bg-neutral-50 dark:hover:bg-neutral-700 hover:border-neutral-400 hover:shadow-md transition-all duration-200"
    >
      {/* Real Google SVG colors */}
      <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      <span className="text-sm font-medium text-neutral-700 dark:text-neutral-200">
        Continue with Google
      </span>
    </button>
  );
}

export default SocialAuth;